<template>
  <div class="download">
    <div style="background: linear-gradient(180deg, #fde6e7 0%, #ffffff 100%)">
      <div class="container">
        <div style="background: #ffffff">
          <div class="container modal-content">
            <div class="modal-left">
              <div class="title">企业投融资</div>
              <div class="text">帮助企业解决融资难题、香港补贴难题</div>
            </div>
            <div class="modal-right">
              <img src="/static/ds/product-img-2.png" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
@import url("./company-financing.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-financing/company-financing.vue